import { Button, Row } from "@commonlibs";
import { useTheme } from "styled-components";
import QuerySearchBar from "ui/common/containers/QuerySearchBar/QuerySearchBar";
import useTranslate from "ui/locale/hooks/useTranslate";
import { TableActionsRoot, TableName, TableToolbar } from "./TableActions.styles";
import { TableActionsProps } from "./TableActions.types";
import RefreshIconButton from "./RefreshIconButton/RefreshIconButton";
import DateRangeFilterDropdown from "ui/common/containers/DateRangeFilterDropdown/DateRangeFilterDropdown";

const TableActions = ({
    title,
    onExport,
    onAddItem,
    search = true,
    textAddItem,
    addingItem = false,
    nothingToShow,
    exporting = false,
    onRedeemPoints,
    onInviteUser,
    onRefresh,
    refreshing = false,
    dateRangeFilter,
    rightToolbar,
    leftToolbar
}: TableActionsProps) => {
    const { spacing } = useTheme();
    const translate = useTranslate();

    return (
        <TableActionsRoot hasTitle={Boolean(title)}>
            {title && <TableName variant="h4Strong">{title}</TableName>}
            <TableToolbar hasTitle={Boolean(title)} alignItems="center" wrapGap={spacing["4"]} gap={spacing["4"]}>
                {leftToolbar && leftToolbar}
                <Row alignItems="center" gap={spacing["4"]}>
                    {onRefresh && <RefreshIconButton onRefresh={onRefresh} refreshing={refreshing} />}
                    {search && <QuerySearchBar size="sm" css={{ width: "15rem" }} />}
                </Row>
                <Row justifyContent="space-between" alignItems="center" wrap wrapGap={spacing["4"]} gap={spacing["4"]}>
                    {onRedeemPoints && (
                        <Button size="md" onClick={onRedeemPoints}>
                            {translate("redeem")}
                        </Button>
                    )}
                    {dateRangeFilter && <DateRangeFilterDropdown />}
                    {onExport && (
                        <Button size="md" variant="secondary" onClick={onExport} loading={exporting} disabled={nothingToShow}>
                            {translate("export")}
                        </Button>
                    )}
                    {onAddItem && (
                        <Button size="md" onClick={onAddItem} loading={addingItem}>
                            {textAddItem || translate("add")}
                        </Button>
                    )}
                    {onInviteUser && (
                        <Button size="md" onClick={onInviteUser}>
                            {translate("invite")}
                        </Button>
                    )}
                    {rightToolbar && rightToolbar}
                </Row>
            </TableToolbar>
        </TableActionsRoot>
    );
};

export default TableActions;
